import React, {useEffect, useState} from 'react'
import MarkDownRenderer from '../MarkdownRender'
import {Grid} from '@material-ui/core/'
import Tooltip from 'react-tooltip-lite'

const BrowserCompatibility = props => {
    const browserlist = process.env.REACT_APP_SUPPORTED_BROWSER
    const title = process.env.REACT_APP_SUPPORTED_BROWSER_TEXT
    return (
        <Tooltip
            content={<Tooltipcontent browserlist={browserlist} />}
            direction="up-start"
            className="target"
            tipContentClassName="browser__support--tooltip"
            arrow={false}
        >
            <MarkDownRenderer value={title} />
        </Tooltip>
    )
}
const Tooltipcontent = props => {
    let browserlist = props.browserlist.split(',')
    return (
        <Grid item xs className="tooltip__content">
            {browserlist.map(b => {
                return <BrowserCard browser={b} />
            })}
        </Grid>
    )
}
const BrowserCard = props => {
    let browserDetails = props.browser.split('~')
    let backetPath = process.env.REACT_APP_BUCKET_PATH
    return (
        <>
            <Grid item xs className="browser__cards">
                <img src={backetPath + browserDetails[1]} alt="img"></img>
                <div className="browser-name">{browserDetails[0]}</div>
            </Grid>
        </>
    )
}
export default BrowserCompatibility
